export default __webpack_public_path__ + "static/media/bulb.92490e30.svg";